const { REACT_APP_CONTEXT_PATH } = process.env;

export const FAQApi = ({ brandId, branchId }) => {
  return {
    apiUrl:
      REACT_APP_CONTEXT_PATH +
      `/app/suggest_questions/${brandId}/${branchId}`,
  };
};
